export class MicrophoneUnavailableError extends Error {
    constructor(cause: unknown) {
        super(`Microphone unavailable: ${(cause as Error)?.message ?? cause}`);
        this.name = 'MicrophoneUnavailableError';
    }
}
